
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-spaces",
      function () {
        return require("private-next-pages/office-spaces/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-spaces"])
      });
    }
  